import { Environment } from 'ha/config';

import { OneTrustOptions } from '../types';
import { TEST } from '../constants';

export const oneTrustDomainKey = ({ env, key }: OneTrustOptions) => {
  switch (env) {
    case Environment.PRODUCTION:
    case Environment.STAGE:
      return key;

    default:
      return key.includes(TEST) ? key : `${key}${TEST}`;
  }
};
